import React, { Component } from "react";
import GastoCorrienteTabla from "./GastoCorrienteTabla";
import { connect } from "react-redux";
import { getGCList } from './GastoCorrienteAction'
import { withRouter } from 'react-router-dom';

class GastoCorrienteContainer extends Component {

    componentDidMount() {
        //console.log("AlumnoContainer");
        this.props.dispatch(getGCList());
    }

    render() {
        return (
            <div>
                <GastoCorrienteTabla />
            </div>
        );
    }
}

export default connect()(GastoCorrienteContainer);
